import { useQuery } from "@tanstack/react-query";
import lensService from "../../../services/lensService";

const usePlaybookChangelog = (key: string | undefined) =>
    useQuery({
        queryKey: ["lens", "changelog", key],
        queryFn: () => lensService.fetchChangelog(key as string),
        enabled: !!key,
    });

export default usePlaybookChangelog;
